import React, { useEffect } from 'react';
import { useController, UseControllerProps } from 'react-hook-form';
import Icon from '@common/assets';

import classnames from 'classnames/bind';
import styles from '../attachedFile.module.scss';
const cx = classnames.bind(styles);

type ReferenceUrlsProps = UseControllerProps;

const ReferenceUrls = (props: ReferenceUrlsProps) => {
  const { field: referenceUrlsField } = useController(props);

  const urlEls = referenceUrlsField.value.map((url: string, index: number) => {
    const handleChange = (value: string) => {
      const newUrls = referenceUrlsField.value.map((url: string, i: number) => {
        if (index === i) return value;
        else return url;
      });
      referenceUrlsField.onChange(newUrls);
    };

    const handleDelete = () => {
      const newUrls = referenceUrlsField.value.filter((url: string, i: number) => {
        return index !== i;
      });
      referenceUrlsField.onChange(newUrls);
    };

    return (
      <div key={index} className={cx('inputArea')}>
        <input
          value={url}
          onChange={(e) => handleChange(e.target.value)}
          className={cx('input')}
          type="text"
          placeholder={'참조 URL을 입력해 주세요.'}
        />
        <a className={cx('btnInputDelete')} onClick={handleDelete} role="button">
          <Icon name="deleteLight" width={28} height={28} />
        </a>
      </div>
    );
  });

  const appendUrl = () => referenceUrlsField.onChange([...referenceUrlsField.value, '']);

  useEffect(() => {
    if (referenceUrlsField.value.length === 0) {
      appendUrl();
    }
  }, [referenceUrlsField.value]);

  return (
    <>
      {urlEls}
      <a className={cx('btnAdd')} role="button" onClick={appendUrl}>
        <Icon name="addLight" width={24} height={24} />
        추가
      </a>
    </>
  );
};

export default ReferenceUrls;
